

<div class="header">
  <div class="imageContainer">
    <div class="circle-name-xl user-img" >
      {{ getShortName(userData?.fullName) }}
    </div>
  </div>
  <div class="name prettyLetters" [ngClass]="{'nameMobile': isMobile}">
    {{userData?.fullName}}
  </div>
</div>
<div class="body" [ngClass]="{'bodyMobile': isMobile}">
  <div class="inputRow" [ngClass]="{'inputRowMobile': isMobile}" *ngIf="!isEmailUpdate">
    <mat-form-field class="flex1" id="firstName">
      <mat-label>{{'PROFILE.FIRST_NAME_INPUT_PLACEHOLDER' | translate}}</mat-label>
      <input type="text" matInput [formControl]="firstName" autocomplete="off" placeholder="" [ngClass]="{'errorBorder': firstName?.errors?.['required'] && firstName?.dirty}" />
      <mat-error *ngIf="firstName?.errors?.['required']">{{'ERROR.REQUIRED' | translate}}</mat-error>
    </mat-form-field>
    <mat-form-field class="flex1" id="lastName">
      <mat-label>{{'PROFILE.LAST_NAME_INPUT_PLACEHOLDER' | translate}}</mat-label>
      <input type="text" class="lastNameInput" matInput [formControl]="lastName" autocomplete="off" placeholder="" [ngClass]="{'errorBorder': lastName?.errors?.['required'] && lastName?.dirty}"/>
      <mat-error *ngIf="lastName?.errors?.['required']">{{'ERROR.REQUIRED' | translate}}</mat-error>
    </mat-form-field>
  </div>
  
  <div class="inputRow" [ngClass]="{'inputRowMobile': isMobile , 'inputRowMobileLast': isMobile , 'emailUpdate':isEmailUpdate && !isMobile}">
    <mat-form-field class="flex1" id="email">
      <mat-label>{{'PROFILE.EMAIL_INPUT_PLACEHOLDER' | translate}}</mat-label>
      <input type="text" matInput [formControl]="email" autocomplete="off" placeholder="" [ngClass]="{'errorBorder': (email?.errors?.['required'] || email?.errors?.['pattern']) && email?.touched}"/>
      <mat-error *ngIf="email?.errors?.['pattern']">{{'ERROR.INVALID_EMAIL' | translate}}</mat-error>
      <mat-error *ngIf="email?.errors?.['required']">{{'ERROR.REQUIRED' | translate}}</mat-error>
    </mat-form-field>
    <app-international-phone class="flex1" id="phone_number"  *ngIf="!isEmailUpdate" 
      [disabled]="true" [newStyles]="true" [newBlueLightStyle]="false"
      (phoneChanged)="onPhoneChanged($event)"  [label]="'Phone'"
      [value]="phone"  
    ></app-international-phone>
  </div>
</div>
<div class="footer" [ngClass]="{'footerMobile': isMobile}">
  <button class="home365-button primary flex center-vr" [ngClass]="{'home365-mobile-button': isMobile}"(click)="submit()" [disabled]="!form.valid">
    {{'GENERAL_TEXTS.SAVE_BUTTON_TEXT' | translate}}
  </button>
</div>
